export const COOKIE_SCRIPT_KEY = 'CookieScriptConsent' as const

export enum COOKIE_SCRIPT_CATEGORIES {
  TARGETING = 'targeting',
  PERFORMANCE = 'performance',
  FUNCTIONALITY = 'functionality',
  STRICTLY_NECESSARY = 'strict',
  UNCLASSIFIED = 'unclassified',
}
